// extracted by mini-css-extract-plugin
module.exports = {"container":"app-summary-module--container--3fAQ2","appName":"app-summary-module--appName--1_09j"};